import {
  useGetCurrentUserQuery,
  useGetWorkspacesQuery,
} from '@carboncopyco/data';
import { useParams } from 'react-router-dom';

export function useHasAccess() {
  const { organizationId, workspaceId } = useParams<{
    organizationId: string;
    workspaceId: string;
  }>();

  const { data: userData } = useGetCurrentUserQuery();
  const { data: workspaces } = useGetWorkspacesQuery({
    organizationId,
  });

  const hasOrgAccess = userData?.user.organizations.includes(
    Number(organizationId)
  );
  const hasWorkspaceAccess = workspaces
    ?.map((workspace) => workspace.id.toString())
    .includes(workspaceId);

  return {
    hasOrgAccess,
    hasWorkspaceAccess,
  };
}
